import { render, staticRenderFns } from "./extUser.vue?vue&type=template&id=3f945b86&scoped=true&"
import script from "./extUser.vue?vue&type=script&lang=ts&"
export * from "./extUser.vue?vue&type=script&lang=ts&"
import style0 from "./extUser.vue?vue&type=style&index=0&id=3f945b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f945b86",
  null
  
)

export default component.exports